import JoinPage from 'src/pages/JoinPage';
import SigninPage from '../pages/Signin';
import { Navigate, Route, Routes } from 'react-router-dom';
import SignUp from 'src/pages/SignUp';
import OTPVerification from 'src/pages/OTPVerification';
import ForgotPassword from 'src/pages/ForgotPassword';
import SetNewPassword from 'src/pages/SetNewPassword';
import SimpleLayout from 'src/layouts/simple';
import PrivacyPolicy from 'src/pages/PrivacyPolicy';
import DeleteAccount from 'src/pages/DeleteAccount';

export default function AuthRouter() {
  return (
    <Routes>
      <Route element={<SimpleLayout />}>
        <Route path="*" element={<Navigate to={`/`} replace />} />
        <Route path={'/'} element={<SigninPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/user/reset-password" element={<SetNewPassword />} />
        <Route path="/join/:email" element={<JoinPage />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/otp" element={<OTPVerification />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Route>
    </Routes>
  );
}
